import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import LogoImage from '../../../../assets/intealth-logo-with-motto.png';
interface PdfHeaderProps {
  data: any;
}
export const PdfTitleSection: React.FC<PdfHeaderProps> = (props) => {
  const styles = StyleSheet.create({
    image: {
      height: 'auto',
      width: '30%'
    },
    text: {
      fontSize: '8px',
      fontFamily: 'Libre Franklin'
    },
    leftColumn: {
      flexDirection: 'row',
      marginBottom: 5
    },
    title: {
      fontSize: '14px',
      paddingTop: 10
    },
    row: {
      width: '100%'
    },
    bannertext: {
      marginTop: 10,
      fontSize: '22px',
      backgroundColor: '#EBF8FA',
      marginBottom: '7px',
      color: '#288C9C',
      padding: '2.5px 2.5px 2.5px 5px',
      fontFamily: 'Libre Franklin Bold',
      borderBottom: '1px solid #288C9C',
      borderTop: '1px solid #288C9C',
      textAlign: 'center',
      alignContent: 'center'
    },
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: '9px',
      fontFamily: 'Libre Franklin'
    },
    label: {
      fontSize: '10px',
      fontFamily: 'Libre Franklin Bold',
      paddingBottom: '8px'
    },
    labelValue: {
      fontSize: '9px',
      paddingBottom: '8px'
    },
    headerText: {
      width: 280,
      color: '#414370',
      fontFamily: 'Libre Franklin Bold',
      textAlign: 'right',
      lineHeight: 1.3
    }
  });

  const inclusions = props.data?.includedFiles?.join('; ') || 'None';

  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <Image style={styles.image} src={LogoImage} />
        <Text style={[styles.headerText, { marginLeft: 10 }]}>ECFMG® Credential Verification for Health Professionals</Text>
      </View>
      <View style={styles.leftColumn}>
        <View style={{ ...styles.row, paddingBottom: 5 }}>
          <Text style={[styles.bannertext, { fontFamily: 'Libre Franklin Bold' }]}>Verification Status Report</Text>
          <View>
            <View style={styles.container}>
              <Text style={styles.label}>Report Issued: </Text>
              <Text style={styles.labelValue}>{props.data.dateOfIssued}</Text>
            </View>

            <View style={styles.container}>
              <Text style={styles.label}>Issued To:</Text>
            </View>

            <View style={{ flexDirection: 'row', fontFamily: 'Libre Franklin'}}>
              <Text style={{ ...styles.labelValue, width: '100%' }}>
                {props.data.sendDestination}
                {props.data.sendDestinationAddressLine1 && `, ${props.data.sendDestinationAddressLine1}`}
                {props.data.sendDestinationAddressLine2 && `, ${props.data.sendDestinationAddressLine2}`}
                {props.data.sendDestinationCity && `, ${props.data.sendDestinationCity}`}
                {props.data.sendDestinationState && `, ${props.data.sendDestinationState}`}
                {props.data.sendDestinationZipCode && ` ${props.data.sendDestinationZipCode}`}
                {props.data.sendDestinationCountry && `, ${props.data.sendDestinationCountry}`}
              </Text>
            </View>

            <View style={[styles.container]}>
              <Text style={styles.label}>Inclusions:</Text>
            </View>
            <View>
              <Text style={styles.labelValue}>{inclusions}</Text>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};
export default PdfTitleSection;
